import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-new-movement',
		path: '/dashboard/start-a-movement',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_new_movement" */ './index'), {
			exportName: 'AdminNewMovement',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
